export default function initCustomSelect(wrapper: HTMLElement) {
	const selects = wrapper.querySelectorAll('.yieldingo-form-question-select') as NodeListOf<HTMLDivElement>;

	let key = 0;
	selects.forEach(selectWrapper => {
		selectWrapper.classList.remove('open');
		selectWrapper.dataset.key = key.toString();

		const select = selectWrapper.querySelector('select');
		const options = select.querySelectorAll('option');

		const selectedItem = document.createElement('div');
		selectedItem.classList.add('select-selected');
		selectedItem.innerHTML = `<span class="value"></span><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path id="Vector" d="M21.0098 7.98813C21.0095 7.78928 20.95 7.59501 20.8388 7.43015C20.7276 7.26529 20.5698 7.13732 20.3855 7.06259C20.2013 6.98785 19.9989 6.96974 19.8043 7.01058C19.6097 7.05141 19.4317 7.14934 19.293 7.29184L12 14.5848L4.70703 7.29184C4.61489 7.19586 4.50452 7.11924 4.38239 7.06645C4.26026 7.01367 4.12883 6.98578 3.99578 6.98443C3.86274 6.98307 3.73077 7.00828 3.60759 7.05857C3.48441 7.10886 3.37251 7.18322 3.27843 7.2773C3.18435 7.37138 3.10999 7.48328 3.0597 7.60646C3.00941 7.72964 2.9842 7.86161 2.98556 7.99465C2.98691 8.12769 3.0148 8.25913 3.06758 8.38126C3.12037 8.50339 3.19699 8.61375 3.29297 8.7059L11.293 16.7059C11.4805 16.8934 11.7348 16.9987 12 16.9987C12.2652 16.9987 12.5195 16.8934 12.707 16.7059L20.707 8.7059C20.8029 8.6126 20.8792 8.50099 20.9312 8.3777C20.9832 8.25441 21.0099 8.12194 21.0098 7.98813Z" style="fill:currentcolor;"/></svg>`;
		const selectedValue = selectedItem.querySelector('span');
		selectWrapper.appendChild(selectedItem);

		const itemsWrapper = document.createElement('div');
		itemsWrapper.classList.add('select-items-wrapper');
		const items = document.createElement('div');
		items.classList.add('select-items');
		itemsWrapper.dataset.key = key.toString();
		document.body.appendChild(itemsWrapper);
		itemsWrapper.appendChild(items);
		reposition();

		options.forEach(option => {
			const item = document.createElement('div');
			item.classList.add('select-item');
			item.dataset.value = option.value;
			item.innerHTML = option.innerHTML;

			if (option.value === select.value) {
				item.classList.add('selected');
				selectedValue.innerHTML = option.innerHTML;
				selectedItem.dataset.value = option.value;
			}

			if (option.disabled) {
				item.classList.add('disabled');
			}
			else {
				item.addEventListener('click', () => {
					select.value = option.value;
					selectedValue.innerHTML = option.innerHTML;
					selectedItem.dataset.value = option.value;
					items.querySelectorAll('.selected').forEach(selected => {
						selected.classList.remove('selected');
					});
					select.dispatchEvent(new Event('change'));
					item.classList.add('selected');
					selectWrapper.classList.remove('open');
					itemsWrapper.classList.remove('open');
				});
			}

			items.appendChild(item);
		});

		selectedItem.addEventListener('click', e => {
			e.stopPropagation();
			closeAll(selectWrapper);
			reposition();
			selectWrapper.classList.toggle('open');
			itemsWrapper.classList.toggle('open');
		});

		window.addEventListener('resize', () => {
			reposition();
		});
		wrapper.addEventListener('change-step', () => {
			setTimeout(() => {
				reposition();
			}, 500);
		});

		function reposition() {
			const boundingBox = selectWrapper.getBoundingClientRect();
			let x = boundingBox.left + window.scrollX;
			let y = boundingBox.y + boundingBox.height + window.scrollY;
			let width = boundingBox.width;

			if (x < 0) {
				x = 0;
			}
			else if (x > document.body.getBoundingClientRect().width) {
				x = 0;
			}

			//console.log(itemsWrapper, x, y, width);

			itemsWrapper.style.top = y + 'px';
			itemsWrapper.style.width = width + 'px';
			itemsWrapper.style.left = x + 'px';
		}

		key++;
	});

	function closeAll(current: HTMLDivElement | null = null) {
		selects.forEach(select => {
			if (select === current) {
				return;
			}
			select.classList.remove('open');
			document.querySelector(`.select-items-wrapper[data-key="${select.dataset.key}"]`).classList.remove('open');
		});
	}

	document.addEventListener('click', () => {
		closeAll();
	});
}
